import React from 'react'

import './Panels.css'

export type Props = {
  id?: string
  className?: string
  children: React.ReactNode
}

function Panel(props: Props) {
  const { className } = props

  return (
    <div
      id={props.id}
      className={className ? className : ''}>
      {props.children}
    </div>
  )
}

export default Panel
